export const NOTIFICATION_BANNER_ID = "notification-banner"
export const NOTIFICATION_BANNER_DATA_TESTID = "notification-banner"
export const NOTIFICATION_BANNER_DISPLAYED_EVENT = "notificationBannerDisplayed"
export const NOTIFICATION_BANNER_COOKIE_NAME = "notification_banner"
